import { SettingsAPI } from '@/api';
import { IApiError } from '@/models/apiError.model';
import { IGetSettingsResponse, IUpdateSettingsDTO, IUpdateSettingsResponse } from '@/models/settings.model';
import { formatApiError } from '@/utils';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { SETTINGS_SLICE_NAME } from './models';

export const getSettings = createAsyncThunk<IGetSettingsResponse, void, { serializedErrorType: IApiError }>(
  `${SETTINGS_SLICE_NAME}/getSettings`,
  async () => {
    const response = await SettingsAPI.getSettings();
    return response.data;
  },
  { serializeError: formatApiError },
);

export const updateSettings = createAsyncThunk<
  IUpdateSettingsResponse,
  IUpdateSettingsDTO,
  { serializedErrorType: IApiError }
>(
  `${SETTINGS_SLICE_NAME}/updateSettings`,
  async (data: IUpdateSettingsDTO) => {
    const response = await SettingsAPI.updateSettings(data);
    return response.data;
  },
  { serializeError: formatApiError },
);
